import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdEmailSelfServeIpAddressesCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdEmailSelfServeIpAddressesProps,
  PostCompaniesCompanyIdEmailSelfServeIpAddressesResult,
  PostCompaniesCompanyIdEmailSelfServeIpAddressesResultErrors,
} from "./types";

/**
 * POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/ip_addresses" endpoint
 */
export const postCompaniesCompanyIdEmailSelfServeIpAddresses = reactQueryMutationAdapter(
  postCompaniesCompanyIdEmailSelfServeIpAddressesCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostCompaniesCompanyIdEmailSelfServeIpAddressesResultErrors>()(
    (
      props: PostCompaniesCompanyIdEmailSelfServeIpAddressesProps
    ): Promise<PostCompaniesCompanyIdEmailSelfServeIpAddressesResult> => {
      // The controller reads camelCase params (name, targetIpCount), like the other self-serve actions.
      const { companyId, appGroupId, ...requestBody } = props;
      return fetch(
        `/companies/${companyId}/email_self_serve/${appGroupId}/ip_addresses`,
        "POST",
        requestBody,
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
